// @flow

import { identity } from 'lodash';

const
	FB_SHARE_URL = process.env.REACT_APP_SHARE_URL || '',
	protocol = window.location.protocol;

const CURRENT_YEAR = process.env.REACT_APP_CURRENT_YEAR || "2025";


const getEncodedJson = (object: Object) => btoa(encodeURIComponent(JSON.stringify(object)));

const getLinkForShare = (object: Object, type) =>
	`${protocol}${FB_SHARE_URL}${type}/${getEncodedJson(object)}`;

const getTimestamp = () => window.Date.now().toString().substr(-4);

const shareTwitter = data => {


	const
		data_for_share = {
			league_id: data.league_id,
			team_id: data.team_id,
		},
		share_endpoint = data.share_type === 'league' ? 'draft_league_invite' : '',
		href = getLinkForShare(data_for_share, share_endpoint),
		messages = {
			league_share_message:
			'I have entered in ' + data.league_name + ' comp on the new and improved ' +
			`NRL Fantasy Draft game! Looking forward to season ${CURRENT_YEAR}. ` +
			'Sign up and join me here ',
			team_inseason_share_message:
				'I scored <256 in round 5 in leaguename. How did you go this week?',
			team_preseason_message:
				'I have just registered for NRL Fantasy Draft! Sign up and join in here ',
		},

		message = messages.league_share_message;

	data.tc = getTimestamp();
	window.open(
		'https://twitter.com/share?url=' + encodeURIComponent(href) +
		'&text=' + encodeURIComponent(message),
		'twitter-share-dialog',
		'width=626,height=436',
	);
};

const shareFacebook = data => {

	const share_endpoint = data.share_type === 'league' ? 'draft_league_invite' : '';
	const FB = window.FB,
		data_for_share = {
			league_id: data.league_id,
			team_id: data.team_id,
			tc: getTimestamp(),
		};


	FB.ui({
		method: 'share',
		display: 'popup',
		href: getLinkForShare(data_for_share, share_endpoint),
	}, identity);
};

export const socialShare = function (data: Object) {

	if (data.sc_type === 'tw') {
		shareTwitter(data);
	}
	else {
		shareFacebook(data);
	}
};


export default socialShare;


// WEBPACK FOOTER //
// ./src/components/SocialShare/index.js